import { Paper, Stack, Typography } from "@mui/material";

const SafetyBox = () => (
  <Stack
    component={Paper}
    direction="row"
    className="grey"
    variant="outlined"
    borderRadius="4px"
    alignItems="center"
    justifyContent="center"
    gap={1}
    py="10px"
    px={2}
    border="1px solid #E5E5E5"
  >
    <img src="/assets/svg/bcms-blue.svg" alt="logo" />
    <Stack className="safety" direction="row" gap={0.5} alignItems="center">
      <img src="/assets/svg/safety.svg" alt="logo" />
      <Typography color="#077834" fontWeight="600">
        Safety
      </Typography>
    </Stack>
  </Stack>
);

export default SafetyBox;
